import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols max-w-[1144px] max-w-176 w-full items-start self-stretch gap-4" }

import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CommunicationOptionsHeader',
  props: {
    content: {},
    id: {},
    name: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FormStepInputs, {
      step: {
        stepName: _ctx.name,
        formInputs: _ctx.content,
      }
    }, null, 8, ["step"])
  ]))
}
}

})